import { ApiResponse } from "@/api/types";
import { computed } from "@vue/composition-api";
import { useComponentInstance } from "./useComponentInstance";
import { checkVideoBundleUnlockingLogsApproved } from "@/helpers/contract-helper";

export const useVideoBundleUnlockingLogsApproved = () => {
  const root = useComponentInstance();

  const isVideoBundleUnlockingLogsApproved = computed<boolean>(() => {
    const partnerUser = root.$store.state.domains.user.partnerUser as
      | ApiResponse.PartnerUser
      | undefined;

    if (!partnerUser) {
      return false;
    }

    const contracts = partnerUser.partner.contracts || [];

    return !!contracts?.find(contract =>
      checkVideoBundleUnlockingLogsApproved(contract)
    );
  });

  return { isVideoBundleUnlockingLogsApproved } as const;
};
